export default "__VITE_ASSET__B32bZ$9C__"